import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

// TODO: check if we can remove this one
export class A extends PureComponent {
    static propTypes = {
        href: PropTypes.string,
        destination: PropTypes.string,
        to: PropTypes.string,
        children: PropTypes.node,
    }

    render() {
        const { children = null, ...props } = this.props;
        const destination = props.to || props.href || props.destination;

        return (
            <a
                href={destination}
                {...this.props}
            >
                {children}
            </a>
        );
    }
}

export default A;
